var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filter-popover',{attrs:{"value":_vm.value,"label-position":"left","fields":_vm.fields,"count":_vm.count,"disabled":_vm.disabled,"with-organization":""},on:{"change":_vm.change,"clear":_vm.clear,"confirm":_vm.confirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }